// Mirrors HologramRenderer.MaxLines: a PlayerHolo on GrieferGames holds three lines.
export const MAX_HOLOGRAM_LINES = 3;

// Mirrors HologramRenderer.LastRankPosition: {rank.position} is sized for two digits.
export const LAST_RANK_POSITION = 99;

interface RepeatedLine {
    repeatCount: number;
}

export function usedHologramLines(lines: readonly RepeatedLine[]): number {
    return lines.reduce((sum, line) => sum + Math.max(1, line.repeatCount), 0);
}

// The most a line may repeat while the others keep their lines; never below 1, so an over-budget
// layout loaded from before the limit still shows its own value in the input.
export function maxRepeatCount(lines: readonly RepeatedLine[], lineIndex: number): number {
    const others = usedHologramLines(lines) - Math.max(1, lines[lineIndex].repeatCount);
    return Math.max(1, MAX_HOLOGRAM_LINES - others);
}

export function lastRankStart(repeatCount: number): number {
    return LAST_RANK_POSITION - Math.max(1, repeatCount) + 1;
}

// The backend matches excluded names ignoring case, so a second spelling of the same name adds nothing.
export function withExcludedName(names: readonly string[], name: string): readonly string[] {
    const trimmed = name.trim();
    if (trimmed.length === 0) return names;
    if (names.some(existing => existing.toLowerCase() === trimmed.toLowerCase())) return names;
    return [...names, trimmed];
}
